export const BalsasStops = {
  350: {
    1: 'Santos',
    2: 'Guarujá',
  },
  351: {
    1: 'São Sebastião',
    2: 'Ilhabela',
  }
}
